import { Component, Input } from '@angular/core';
import { getLLCAddressString } from '@core/util/address';
import { getMailingBranch, getServiceBranch } from '@core/util/llc';
import { Branch, LLCTransaction } from '@models/llc-mortgages';
import { MatterMortgage, TransactionType } from '@models/mortgage';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';

@Component({
	selector: 'app-llc-lender-details',
	templateUrl: './lender-details.component.html',
	standalone: false,
})
export class LLCLenderDetailsComponent {
	public _mortgage: LLCTransaction;
	public _matterMortgage: MatterMortgage;
	public mailingBranch: Branch;
	public serviceBranch: Branch;
	public serviceBranchAddress: string;
	public mailingBranchAddress: string;
	public transactionTypes = TransactionType;

	constructor(private mortgageDispatch: MatterMortgageDispatch) {}

	@Input() set matterMortgage(m: MatterMortgage) {
		this._matterMortgage = m;
	}

	@Input() set mortgage(m: LLCTransaction) {
		this._mortgage = m;

		this.serviceBranch = getServiceBranch(m?.data);
		this.serviceBranchAddress = this?.serviceBranch?.address
			? getLLCAddressString(this?.serviceBranch?.address)
			: null;
		this.mailingBranch = getMailingBranch(m?.data);
		this.mailingBranchAddress = this?.mailingBranch?.address
			? getLLCAddressString(this?.mailingBranch?.address)
			: null;
	}

	setActingForMortgagee(value: boolean) {
		this.mortgageDispatch.updateMortgage(this._matterMortgage.id, {
			actingForMortgagee: value,
		});
	}

	updateLenderCollects(value: boolean) {
		this.mortgageDispatch.setLenderCollectsPropertyTaxes(
			this._matterMortgage.id,
			value,
		);
	}
}
